// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://127.0.0.1:8000/api/',
  // apiUrl: 'http://172.18.208.1:8000/api/',
  apiUrl: 'https://develop.momsandtots.biz/api/',
  // apiUrl: 'https://api.momsandtots.biz/api/',
  // apiUrl: 'https://develop.momsandtots.biz/api/',

  oneSignalAppId: '521001be-97ab-4f55-8aff-0c21a284643f',
  remitentId: '963472845157',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
